import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEOHelmet({ title, description, image }) {
  const siteName = 'ShiftMatch';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Find Flexible Work in Australia`;
  const desc = description || 'Find casual shifts, short-term work, and flexible jobs across Australia. Sign up free as a worker or employer.';
  const img = image || 'https://shiftmatch.work/og-image.png';
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content="https://shiftmatch.work" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
